// Copyright (c) 2021 Deere & Company

import EditableField from './editable-field';
import LabeledFormInput from './labeled-form-input';
import PropTypes from 'prop-types';
import React from 'react';

const LabeledTextArea = ( {
    className, highlightClass, isEditable, value, link, formatter, label, isRequired, type = 'text', vsrMessage, ...props
} ) => (
    <LabeledFormInput
        className={`${className} ${highlightClass} labeled-input`}
        label={label}
        isRequired={isRequired}
    >
        <EditableField
            isEditable={isEditable}
            value={formatter ? formatter( value ) : value}
            link={link}
        >
            <textarea
                {...props}
                onChange={props.onChange}
                type={type}
                value={value}
                disabled={props.disabled}
            />
        </EditableField>
    </LabeledFormInput>
);

LabeledTextArea.displayName = 'LabeledTextArea';
LabeledTextArea.propTypes = {
    className: PropTypes.string,
    formatter: PropTypes.func,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    type: PropTypes.string,
    value: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] ),
    link: PropTypes.string,
    vsrMessage: PropTypes.string,
    isRequired: PropTypes.bool,
    disabled: PropTypes.bool
};

export default LabeledTextArea;
